import React from 'react'

// Removed Input, Modal imports
// Added CBInput, CBModal imports
import { CBInput, CBModal } from '../../../core/components/cbd';


const EditStripeModal = ({
	stripeId,
	subId,
	visible,
	handleOk,
	confirmLoading,
	handleCancel,
	newStripeId,
	setNewStripeId,
	newSubId,
	setNewSubId
}) => {

	const handleInputChange = (e) => {
		setNewStripeId(e.target.value)
	}
	const handleSubChange = (e) => {
		setNewSubId(e.target.value) // Keep this handler
	}
	return (
		// Replaced Modal with CBModal
		<CBModal
			title="Edit Stripe"
			visible={visible}
			onPositiveClick={handleOk} // Map onOk
			confirmLoading={confirmLoading} // Assuming CBModal supports this
			onCancelClick={handleCancel} // Map onCancel
		>
			<p className="mb-4">Change the Stripe Info for a User</p> {/* Added margin */}
			{/* Replaced Input.Group with div and spacing */}
			<div className="space-y-4">
				{/* Replaced Input with CBInput */}
				<CBInput
					label={'Current Customer Id'} // Use label prop
					value={stripeId || ''} // Handle potentially null value
					readOnly={true}
					className="pb-4"
				/>
				<CBInput
					label={'Current Sub Id'} // Use label prop
					value={subId || ''} // Handle potentially null value
					readOnly={true}
					className="pb-4"
				/>
				<CBInput
					value={newStripeId}
					label={'New Stripe Id'} // Use label prop
					placeholder={'New Stripe Id'}
					onChange={(val) => setNewStripeId(val)} // Adapt onChange
					className="pb-4"
				/>
				<CBInput
					value={newSubId}
					label={'New Sub Id'} // Use label prop
					placeholder={'New Sub Id'}
					onChange={(val) => setNewSubId(val)} // Adapt onChange
					className="pb-4"
				/>
			</div>
		</CBModal>
	)
}

export default EditStripeModal
